import {ContentPlaceholderController} from './ContentPlaceholderController';
import {DialogController} from './DialogController';
import {DotLottieController} from './DotLottieController';
import * as HashChangeHandler from './HashChangeHandler';
import {IconController} from './IconController';
import {IntersectionEventController} from './IntersectionEventController';
import {L10nController} from './l10nController';
import * as MutationHandler from './MutationHandler';
import {StartOnIntersectionController} from './StartOnIntersectionController';
import {StateEventClassesController} from './StateEventClassesController';
import {TabsController} from './TabsController';
import {TooltipController} from './TooltipController';

document.addEventListener('DOMContentLoaded', () => {
  MutationHandler.listen();
  HashChangeHandler.listen();
});

export {
  ContentPlaceholderController,
  DialogController,
  DotLottieController,
  IconController,
  IntersectionEventController,
  L10nController,
  StartOnIntersectionController,
  StateEventClassesController,
  TabsController,
  TooltipController,
};
